import { render, staticRenderFns } from "./TemplateOrderEdit.vue?vue&type=template&id=04c1f8f7&scoped=true"
import script from "./TemplateOrderEdit.vue?vue&type=script&lang=js"
export * from "./TemplateOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1f8f7",
  null
  
)

export default component.exports